import { createRouter, createWebHistory } from 'vue-router';
import Home from '@/views/HomeView.vue'; // Assuming App.vue is your main component

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/articulos-para-fiestas',
    name: 'ArticulosView',
    alias: '/articulos-para-fiestas.html',
    component: () => import('@/views/ArticulosView.vue'),
  },
  {
    path: '/decoraciones-para-fiestas',
    name: 'DecoracionesView',
    alias: '/decoraciones-para-fiestas.html',
    component: () => import('@/views/DecoracionesView.vue'),
  },
  {
    path: '/venta-de-pinatas-en-jiutepec',
    name: 'PinatasJiutepec',
    alias: '/venta-de-pinatas-en-jiutepec.html',
    component: () => import('@/views/VentaJiutepec.vue'),
  }
  // You can add more routes here as needed
  // {
  //   path: '/about',
  //   name: 'About',
  //   component: () => import('../views/About.vue'), // Example of lazy-loaded component
  // },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      // If a hash is present in the `to` route, scroll to the element
      return {
        el: to.hash, // 'el' property specifies the target element selector
        behavior: "smooth", // Optional: adds smooth scrolling
      };
    } else if (savedPosition) {
      // If a saved scroll position exists (e.g., from browser back/forward)
      return savedPosition;
    } else {
      // Default: scroll to the top of the page
      return { x: 0, y: 0 };
    }
  },
});

export default router;
